import React from "react";
import { SEO, Header, Footer, CustomerHome } from "../../../components";
// import { requestPermission } from "../../../firebase/NotificationsConfig";

const Home = () => {
  // useEffect(() => {
  //   requestPermission();
  // }, []);
  return (
    <>
      <SEO title="Home" />
      <Header />
      <CustomerHome />
      <Footer />
    </>
  );
};

export default Home;
